/**
 * Unix-ish ms threshold below which digit-only strings stay categorical (e.g. "0012", "12").
 * Kept in sync with line chart axis inference (~1970-04-26 when interpreted as ms).
 */
export const LINE_CHART_MIN_LIKELY_TIMESTAMP_MS = 10_000_000_000;

/**
 * Coerce string X values only when datetime-like:
 * — digit-only strings: unix-ms only when |n| ≥ {@link LINE_CHART_MIN_LIKELY_TIMESTAMP_MS}
 * — otherwise Date.parse when it yields a finite time
 * Otherwise preserves the original string (leading zeros, distinct formats).
 */
export function coerceLineChartStringX(raw: string): number | string {
	const trimmed = raw.trim();
	if (trimmed === '') {
		return raw;
	}

	if (/^-?\d+$/.test(trimmed)) {
		const n = Number(trimmed);
		if (
			Number.isFinite(n) &&
			Math.abs(n) >= LINE_CHART_MIN_LIKELY_TIMESTAMP_MS
		) {
			return n;
		}
		return raw;
	}

	const parsed = Date.parse(raw);
	return Number.isFinite(parsed) ? parsed : raw;
}
